// libs
import * as React from 'react'

// components
import GroupHeaderTitle from 'src/components/content_placeholder/components/group_header_title/group_header_title'
import EventBannerPlaceholder from 'src/components/content_placeholder/components/event_banner/event_banner'

const BannerFeedPlaceholder: React.FC = () => (
  <>
    <GroupHeaderTitle />
    <EventBannerPlaceholder />
    <EventBannerPlaceholder />
    <EventBannerPlaceholder />
    <EventBannerPlaceholder />
    <EventBannerPlaceholder />
  </>
)

export default BannerFeedPlaceholder
